module.exports = __webpack_public_path__ + "static/media/arrow-right-white-hover.eebbc21a.svg";